import { Map } from 'immutable'
import * as API from '../../utils/API'
import { loading, loadingSuccess, loadingFailure } from './status'
import mergePayload from './utils/mergePayload'
import Actions from './utils/actions'

const RESOURCE_NAME = 'parametroConcessionaria'

const endpoint = (action, id) => {
  switch (action) {
    case Actions.INDEX:
    case Actions.CREATE:
      return `/concessionarias/${id}/parametros_concessionaria`

    case Actions.SHOW:
    case Actions.UPDATE:
    case Actions.DESTROY:
      return `/parametros_concessionaria/${id}`

    case 'import':
      return '/parametros_concessionaria/import'

    default:
      return ''
  }
}

const resolve = (dispatch, resource) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(loadingParametroConcessionariaSuccess(resource))
  return Promise.resolve(resource)
}

const resolveDestroy = (dispatch, id) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(destroyingParametroConcessionariaSuccess(id))
  return Promise.resolve()
}

const reject = (dispatch, error) => {
  dispatch(loadingFailure(RESOURCE_NAME, error))
  return Promise.reject(error)
}

export const LOADING_PARAMETRO_CONCESSIONARIA_SUCCESS = 'LOADING_PARAMETRO_CONCESSIONARIA_SUCCESS'
export function loadingParametroConcessionariaSuccess(parametroConcessionaria) {
  return {
    type: LOADING_PARAMETRO_CONCESSIONARIA_SUCCESS,
    parametroConcessionaria,
  }
}

export const DESTROYING_PARAMETRO_CONCESSIONARIA_SUCCESS =
  'DESTROYING_PARAMETRO_CONCESSIONARIA_SUCCESS'
export function destroyingParametroConcessionariaSuccess(parametroConcessionariaId) {
  return {
    type: DESTROYING_PARAMETRO_CONCESSIONARIA_SUCCESS,
    parametroConcessionariaId,
  }
}

export function fetchMultipleParametroConcessionaria(parentId) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.INDEX, parentId)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function fetchParametroConcessionaria(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.SHOW, id)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function createParametroConcessionaria(parentId, parametroConcessionaria) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(
      endpoint(Actions.CREATE, parentId),
      'POST',
      parametroConcessionaria
    ).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function updateParametroConcessionaria(id, parametroConcessionaria) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.UPDATE, id), 'PUT', parametroConcessionaria).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function destroyParametroConcessionaria(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return await API.call(endpoint(Actions.DESTROY, id), 'DELETE').then(
      () => resolveDestroy(dispatch, id),
      error => reject(dispatch, error)
    )
  }
}

export function importParametroConcessionaria(multipleParametroConcessionaria) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint('import'), 'POST', multipleParametroConcessionaria).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

const parametroConcessionaria = (state = new Map({}), action) => {
  switch (action.type) {
    case LOADING_PARAMETRO_CONCESSIONARIA_SUCCESS: {
      const { parametroConcessionaria: payload } = action
      return mergePayload(state, payload)
    }

    case DESTROYING_PARAMETRO_CONCESSIONARIA_SUCCESS:
      return state.delete(action.parametroConcessionariaId.toString())

    default:
      return state
  }
}

export default parametroConcessionaria
